export default __webpack_public_path__ + "static/media/defence-nfo-quickbuy-banner.7e8623b3.png";